import { Action, createReducer, on } from '@ngrx/store';
import { AuthState } from '../auth.model';
import { initialState } from './auth.state';
import { ClearAuthStateAction, SetOrgEntriesAction, SetOrgTagAction } from './auth.actions';

const reducer = createReducer(
    initialState,
    on(SetOrgTagAction, (_state: AuthState, { org, configId, roles, scopes, permissions }) => ({
        ..._state,
        org,
        configId,
        roles,
        scopes,
        permissions,
    })),
    on(SetOrgEntriesAction, (state: AuthState, { orgEntries }) => ({ ...state, orgEntries })),
    on(ClearAuthStateAction, () => ({ ...initialState })),
);

export function AuthReducer(state: AuthState, action: Action): AuthState {
    return reducer(state, action);
}
